import { createRouter, createWebHashHistory } from 'vue-router'
import Cookies from 'js-cookie'

// 导入页面组件
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import AiPortrait from '../views/AiPortrait.vue'
import AiAuth from '../views/AiAuths.vue'
import AiPreparation from '../views/AiPreparation.vue'
import AiTeaching from '../views/AiTeaching.vue'
import AiAgent from '../views/AiAgent.vue'
import AiDistillation from '../views/AiDistillation.vue'
import AiReport from '../views/AiReport.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: false, showLayout: false }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false, showLayout: false }
  },
  {
    path: '/ai-portrait',
    name: 'AiPortrait',
    component: AiPortrait,
    meta: { requiresAuth: true, showLayout: true }
  },
  {
    path: '/ai-auth',
    name: 'AiAuth',
    component: AiAuth,
    meta: { requiresAuth: true, showLayout: true }
  },
  {
    path: '/ai-preparation',
    name: 'AiPreparation',
    component: AiPreparation,
    meta: { requiresAuth: true, showLayout: true }
  },
  {
    path: '/ai-teaching',
    name: 'AiTeaching',
    component: AiTeaching,
    meta: { requiresAuth: true, showLayout: true }
  },
  {
    path: '/ai-agent',
    name: 'AiAgent',
    component: AiAgent,
    meta: { requiresAuth: true, showLayout: true }
  },
  {
    path: '/ai-distillation',
    name: 'AiDistillation',
    component: AiDistillation,
    meta: { requiresAuth: true, showLayout: true }
  },
  {
    path: '/ai-report',
    name: 'AiReport',
    component: AiReport,
    meta: { requiresAuth: true, showLayout: true }
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const isAuthenticated = Cookies.get('user_token')

  if (to.meta.requiresAuth && !isAuthenticated) {
    // 需要登录但未登录，跳转到登录页
    next('/login')
  } else if (to.path === '/login' && isAuthenticated) {
    // 已登录访问登录页，跳转到首页
    next('/')
  } else {
    next()
  }
})

export default router